var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FFF5ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4339_173821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8467 19.6666C27.5746 19.6666 25.5441 20.8782 25.5441 23.1167C25.5441 25.6838 29.1452 25.8611 29.1452 27.1508C29.1452 27.6938 28.5403 28.1799 27.5072 28.1799C26.041 28.1799 24.9451 27.5007 24.9451 27.5007L24.4762 29.7596C24.4762 29.7596 25.7386 30.3333 27.4147 30.3333C29.8988 30.3333 31.8535 29.0622 31.8535 26.7855C31.8535 24.0728 28.2374 23.9008 28.2374 22.7038C28.2374 22.2784 28.734 21.8123 29.7641 21.8123C30.9265 21.8123 31.8748 22.3063 31.8748 22.3063L32.3337 20.1246C32.3337 20.1246 31.3018 19.6666 29.8467 19.6666ZM9.05892 19.8313L9.00391 20.1606C9.00391 20.1606 9.95979 20.3406 10.8207 20.6996C11.9292 21.1113 12.0082 21.3509 12.1949 22.0953L14.2293 30.1635H16.9564L21.1577 19.8313H18.4369L15.7373 26.8562L14.6357 20.9016C14.5346 20.22 14.0229 19.8313 13.3965 19.8313H9.05892ZM22.2518 19.8313L20.1174 30.1635H22.7119L24.8389 19.8313H22.2518ZM36.7226 19.8313C36.0969 19.8313 35.7654 20.1759 35.5222 20.7781L31.721 30.1635H34.4419L34.9683 28.5993H38.2831L38.6032 30.1635H41.0039L38.9095 19.8313H36.7226ZM37.0764 22.6227L37.8829 26.4999H35.7223L37.0764 22.6227Z",
    fill: "#1434CB"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    stroke: "#FECBAA",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4339_173821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 10.6667,
    fill: "white",
    transform: "translate(9 19.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.35c123dd85749d0a695ac25ba8ae48e8.svg";
export { ForwardRef as ReactComponent };